import { environment } from './environment.default';

delete environment.branch;
environment.channelName = 'Production';
environment.careboxBaseUrl = 'https://shop.albisana.de/create';
environment.portalUrl = `https://portal.halloalberta.de`;

export { environment };
